/*
 * Purpose: Retry session hydrate after HttpOnly cookie auth (GitHub, magic link, OTP)
 * Last modified: 2026-07-10 | Agent
 * Completeness: 100
 */
const SESSION_RETRIES = 6;
const SESSION_RETRY_MS = 250;

function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export interface AuthBootstrapResult {
  authed: boolean;
  tenantPickRequired: boolean;
  planPickRequired: boolean;
}

export async function bootstrapAuthSession(
  hydrate: () => Promise<void>,
  getState: () => {
    authed: boolean;
    tenantPickRequired: boolean;
    planPickRequired: boolean;
  }
): Promise<AuthBootstrapResult> {
  for (let attempt = 0; attempt < SESSION_RETRIES; attempt += 1) {
    await hydrate();
    const state = getState();
    if (state.authed) {
      return {
        authed: true,
        tenantPickRequired: state.tenantPickRequired,
        planPickRequired: state.planPickRequired,
      };
    }
    if (attempt < SESSION_RETRIES - 1) {
      await sleep(SESSION_RETRY_MS);
    }
  }
  return { authed: false, tenantPickRequired: false, planPickRequired: false };
}
